import {AnswerTemplateDto} from "../../../../libs/answer-templates/feature/answer-templates/domain/dtos";

interface Adaptation {
  chat_id: string;
  text: string;
  companies: Array<string>;
  shortcut: string;
}

export function livechatTemplatesSaveCreateAdapter(
  attendanceId: string,
  template: AnswerTemplateDto,
): Adaptation {
  return {
    chat_id: attendanceId,
    text: template.content,
    companies: template.companiesIds,
    shortcut: template.title,
  }
}
